import CryptoJS from "crypto-js";
import SecureStorage from "secure-web-storage";

export default class AppSecureStorage extends SecureStorage {
  constructor() {
    let doc = {
      localStorage: {},
    };
    if (typeof window !== "undefined") {
      doc = window;
    }
    super(doc.localStorage, {
      hash: function hash(key) {
        key = CryptoJS.SHA256(
          key,
          process.env.REACT_APP_STORAGE_ENCRYPTION_KEY
        );
        return key.toString();
      },
      encrypt: function encrypt(data) {
        try {
          const stringValue = JSON.stringify(data);
          data = CryptoJS.AES.encrypt(
            stringValue,
            process.env.REACT_APP_STORAGE_ENCRYPTION_KEY
          ).toString();
          return data;
        } catch (e) {
          return null;
        }
      },
      decrypt: function decrypt(data) {
        try {
          const decryptedData = CryptoJS.AES.decrypt(
            data,
            process.env.REACT_APP_STORAGE_ENCRYPTION_KEY
          ).toString(CryptoJS.enc.Utf8);

          // Ensure the decrypted data is valid JSON
          return JSON.parse(decryptedData);
        } catch (e) {
          return null;
        }
      },
    });
  }

  set(key, value) {
    try {
      const encryptedValue = this.encrypt(value);
      if (encryptedValue !== null) {
        this.storage.setItem(this.hash(key), encryptedValue);
      }
    } catch (e) {}
  }

  get(key) {
    try {
      const encryptedData = this.storage.getItem(this.hash(key));
      if (encryptedData) {
        return this.decrypt(encryptedData);
      }
    } catch (e) {}
    return null; // Return null if there's an error or if data doesn't exist
  }

  remove(key) {
    try {
      this.storage.removeItem(this.hash(key));
    } catch (e) {}
  }
  // added clearAuthData method to clear authentication related data and to preserv lastSeenNotificationTime
  clearAuthData() {
    try {
      const authKeys = [
        "token",
        "tokenExpiry",
        "role",
        "domain",
        "id",
        "name",
        "orgId",
        "profilePicture",
        "permissions",
      ];

      authKeys.forEach((key) => this.remove(key));
    } catch (e) {}
  }
  clearStorage() {
    try {
      this.storage.clear();
    } catch (e) {}
  }
}
